import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/joinPractice/pic4_01.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "kv" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "青年實習培育")
  ])
], -1)
const _hoisted_2 = { class: "sect1" }
const _hoisted_3 = { class: "ctx" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "打造東部青年人才實習培育基地", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 製造業已非勞力密集的產業，大步走向「科技化」，和平電力作為台灣東部重點產業，長期需求機電、電子、化學材料、資訊控制等相關領域人才。近年積極與各大專院校合作，開放大三、大四、碩士生在學期間暑假到廠實習，學生可深入平常難以進入的電廠，了解運作實務、操作平時學校實驗室無法接觸到的分析儀器，將教科書的理論結合成務實的寶貴經驗。 ", -1)
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "salary" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"degree\"><div class=\"item\"><div class=\"tit\">學士級<br>含勞健保</div><div><i class=\"fa-solid fa-caret-down\"></i></div><div class=\"num1\">30K</div></div><div class=\"item\"><div class=\"tit\">碩士級<br>含勞健保</div><div><i class=\"fa-solid fa-caret-down\"></i></div><div class=\"num2\">32K</div></div><div class=\"item\"><div class=\"tit\">畢業後留任<br>另發獎金</div><div><i class=\"fa-solid fa-caret-down\"></i></div><div class=\"num3\">20K</div></div></div>", 1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<section class=\"sect2\"><div class=\"ctx\"><div class=\"gallery\"><div class=\"left\"><div class=\"imgContainer2-1\"></div><div class=\"imgContainer2-2\"></div></div><div class=\"right\"><div class=\"imgContainer2-3\"></div></div></div></div></section>", 1)
const _hoisted_13 = { class: "sect4" }
const _hoisted_14 = { class: "ctx" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, [
  /*#__PURE__*/_createTextVNode("培育青年永續人才 "),
  /*#__PURE__*/_createElementVNode("span", { class: "phoneBreak" }, "台泥實習計畫")
], -1)
const _hoisted_16 = {
  class: "fbLink",
  target: "_blank",
  href: "https://media.taiwancement.com/web_hppc/comm/2025%E6%9A%91%E6%9C%9F%E5%AF%A6%E7%BF%92%E7%94%9F%E7%B5%90%E6%A5%AD%E5%BC%8F%E5%BD%B1%E7%89%87.mp4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-play" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "影片播放", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_21 = { class: "sect3" }
const _hoisted_22 = { class: "ctx" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "學長姐分享", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "yearSlider" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "sectTag" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-ellipsis-vertical" }),
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-ellipsis-vertical" }),
  /*#__PURE__*/_createTextVNode(" 回饋分享")
], -1)
const _hoisted_28 = { class: "practice" }
const _hoisted_29 = {
  key: 0,
  class: "item"
}
const _hoisted_30 = { class: "info" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sign" }, "#")
], -1)
const _hoisted_32 = { class: "right" }
const _hoisted_33 = { class: "tit" }
const _hoisted_34 = { class: "desp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_psan = _resolveComponent("psan")!
  const _component_center = _resolveComponent("center")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_psan, { class: "txt1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("實習期間")
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_psan, { class: "txt2" }, {
                  default: _withCtx(() => [
                    _createTextVNode("保障月薪")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_10
            ])
          ]),
          _hoisted_11
        ])
      ]),
      _hoisted_12,
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_16, [
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }),
            _hoisted_18,
            _hoisted_19,
            _hoisted_20
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("select", {
            class: "yearSelect",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.practiceYear) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUniqueYears(), (year) => {
              return (_openBlock(), _createElementBlock("option", {
                key: year,
                value: year
              }, _toDisplayString(year), 9, _hoisted_24))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.practiceYear]
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUniqueYears(), (year) => {
              return (_openBlock(), _createElementBlock("div", {
                key: year,
                class: _normalizeClass(['btn', {'active': _ctx.practiceYear === year}]),
                onClick: ($event: any) => (_ctx.switchPracticeYear(year))
              }, _toDisplayString(year), 11, _hoisted_26))
            }), 128))
          ]),
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practice, (row, idx) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                (row.year === _ctx.practiceYear || 0 === _ctx.practiceYear)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", {
                        class: "imgContainer3 thumbnail",
                        style: _normalizeStyle(_ctx.setPracticePic(row.thumbnail))
                      }, null, 4),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(row.tit), 1),
                          _createElementVNode("div", _hoisted_34, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.desp, (row2, idx) => {
                              return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(row2), 1))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}